import { Component, OnInit, ViewChild } from '@angular/core';
import { Routes, ActivatedRoute, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { User } from 'app/shared/models/User';
import { AlertMessageComponent } from 'app/shared/components/alert-message/alert-message.component';
import { Location } from '@angular/common';
import { QuestionDetailsModel } from 'app/question/models/question-details-model';
import { ResponseTypeModel } from 'app/question/models/response-type.model';
import { QuestionService } from 'app/question/services/question.service';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';
import { QuestionAnswerModel } from 'app/question/models/question-answer.model';
import { HtmlToTextPipe } from 'app/shared/pipes/htmlToText.pipe';
import { TruncatePipe } from 'app/shared/pipes/truncate.pipe';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

@Component({
    templateUrl: './question-details.component.html',
    styleUrls: ['./question-details.component.css'],
    providers: [ TruncatePipe, HtmlToTextPipe ]
})
export class QuestionDetailsComponent implements OnInit {
    public Editor = ClassicEditor;
    questionDetailsModel: QuestionDetailsModel;
    errors: string[];
    headerTitle: IHeaderTitle;
    submitAttempt = false;
    @ViewChild(AlertMessageComponent, { static: false }) alertMessage: AlertMessageComponent;
    redirectRoutes: Routes;
    questionDetailsFormGroup: FormGroup;
    isEditMode = false;
    userDetails: User;
    isAdmin = false;
    questionId: string;
    responseTypes: ResponseTypeModel[];
    //options: any[] = [];
    editorData: string;
    questionAnswers: QuestionAnswerModel[] = [];
    selectedQuestionId: string;
    questionBankId: string;
    closeResult: string;

    constructor(
        private questionService: QuestionService,
        private activatedRoute: ActivatedRoute,
        private fb: FormBuilder,
        private location: Location,
        private router: Router,
        private htmlToText: HtmlToTextPipe,
        private truncate: TruncatePipe,
        private modalService: NgbModal
    ) { }

    ngOnInit() {
        this.load();
    }

    load(): void {
        this.getResponseTypes();
        this.questionId = this.activatedRoute.snapshot.params['id'];
        this.questionService.get(this.questionId).subscribe(questionInfo => {
            this.questionDetailsModel = questionInfo;
            this.initializeForm(questionInfo);
            this.editorData = questionInfo.title;
            this.headerTitle = {
                title: this.truncate.transform(this.htmlToText.transform(questionInfo.title),125),
                breadcrumbs: [{ title: 'Questions', url: ['/question'] }]
            };
        });

        this.activatedRoute.queryParams.pipe(
            filter((params) => params.questionBankId)
            ).subscribe(params => {
                this.questionBankId = params.questionBankId;
            });


    }
    ngAfterViewInit() {
    }

    getResponseTypes(): void {
        this.questionService.getResponseTypes().subscribe(result => {
            this.responseTypes = result;
        });
    }

    initializeForm(model: QuestionDetailsModel): void {
        this.questionDetailsFormGroup = this.fb.group(
            {
                id: [this.questionId],
                title: [model.title, Validators.required],
                //description: [model.description, Validators.required],
                responseTypeId: [model.responseTypeId],
                responseType: [model.responseType],
                isActive: [model.isActive],
                //options: [model.options],
                weighting: [model.weighting]
            }
        );
    }


    change({ editor }: ChangeEvent) {
        //const editorData = editor.getData();
        //this.questionDetailsFormGroup.get('title').setValue(editorData);
    }

    toggleEditMode(): void {
        this.isEditMode = !this.isEditMode;
    }

    updateQuestion(): void {
        this.submitAttempt = true;
        if (this.questionDetailsFormGroup.valid) {
            const formValue = this.questionDetailsFormGroup.value;
            formValue.questionAnswers = this.questionAnswers;
            formValue.title = this.editorData;


            this.questionService.update(formValue).subscribe(
                response => {
                    this.alertMessage.showMessage();
                },
                error => {
                    this.errors = error.errorList;
                }
            );
        }
    }

    successClicked($event: any): void {
        if (this.questionBankId) {
            this.router.navigate(['./question/questionbank/' + this.questionBankId])
        } else {
            this.router.navigate(['./question']);
        }
    }

    onHide($event: any): void { }

    onBack($event: any): void {
        this.location.back();
    }

    //addTagFn(name) {
    //    return { name: name };
    //}

    onGetQuestionAnswers($event: QuestionAnswerModel[]): void {
        this.questionAnswers = $event;
    }


    deleteQuestion() {
        this.questionService.deleteQuestion(this.selectedQuestionId).subscribe(
            //result => this.load(),
            result => this.location.back(),
            error => console.log(error)
        );
    }
}
